<template>
  <div class="views-bulletin-settings">
    <div class="views-bulletin-settings-wrapper">
      <div class="views-bulletin-settings__header">
        <div class="views-bulletin-settings__header-left">
          內容管理
        </div>
      </div>

      <div class="views-bulletin-settings__body">
        <el-form
          ref="form"
          class="views-bulletin-settings__body-form"
          :model="form"
          :rules="rules"
          status-icon
          :show-message="false"
          label-position="top"
        >
          <el-form-item
            label="影片管理"
            class="views-bulletin-settings__body-form-item"
          >
            <div class="views-bulletin-settings__body-form-item__video__title">
              <ul>
                <li>影片總數：{{ form.video.length }} 部 / 10 部</li>
                <li>影片支援 YouTube 網址，可嵌入至多 10 部影片</li>
                <li>影片網址為<span class="views-bulletin-settings__body-form-item__required--red">必填*</span></li>
                <li>若輸入影片網址後，影片標題及縮圖無法正常顯示，請重新檢查：</li>
                <li>1. 影片網址是否輸入正確</li>
                <li>2. 影片是否可內嵌於網頁上 (iframe)</li>
                <li>3. 影片狀態是否設定為私人影片</li>
                <li>4. 影片類型不支援 Shorts</li>
              </ul>
            </div>
            <el-button
              class="views-bulletin-settings__body-form-item__video__title-button"
              :disabled="form.video.length >= 10"
              @click="addVideo"
            >
              新增影片
            </el-button>
            <draggable
              v-model="form.video"
              v-bind="dragOptions"
              handle=".handle"
              @change="updateVideoListSortOrder"
            >
              <transition-group>
                <div
                  v-for="item in form.video"
                  :key="item.Sequence"
                >
                  <el-form
                    :ref="`ruleVideo${item.Sequence}`"
                    class="views-bulletin-settings__body-form-item__video"
                    :model="item"
                    :rules="rulesVideo"
                    status-icon
                    :show-message="false"
                    @submit.native.prevent
                  >
                    <div class="views-bulletin-settings__body-form-item__video-left">
                      {{ item.Sequence }}.
                      <i
                        class="el-icon-d-caret views-bulletin-settings__body-form-item__video-left__icon handle"
                        aria-hidden="true"
                      />
                    </div>
                    <div>
                      <el-form-item prop="Url">
                        <el-input
                          v-model="item.Url"
                          placeholder="請輸入影片網址"
                          class="views-bulletin-settings__body-form-item__video-middle__input"
                          maxlength="100"
                          @change="checkVideoUrl(item.Url, item.Sequence - 1)"
                        />
                      </el-form-item>
                      <div v-if="!item.Error">
                        <div class="views-bulletin-settings__body-form-item__video-middle__title">
                          影片標題： {{ item.Title }}
                        </div>
                        <div class="views-bulletin-settings__body-form-item__video-middle__thumbnail-wrapper">
                          影片縮圖：
                          <div v-if="item.Thumbnail !== ''">
                            <img
                              :src="item.Thumbnail"
                              class="views-bulletin-settings__body-form-item__video-middle__thumbnail"
                              alt="影片縮圖"
                            >
                          </div>
                        </div>
                      </div>
                      <div v-if="item.Error">
                        <div class="views-bulletin-settings__body-form-item__video-middle__title">
                          影片標題：
                          <div class="views-bulletin-settings__body-form-item__video-middle__title--red">
                            不支援此影片網址
                          </div>
                        </div>
                        <div class="views-bulletin-settings__body-form-item__video-middle__thumbnail-wrapper">
                          影片縮圖：
                          <div class="views-bulletin-settings__body-form-item__video-middle__title--red">
                            不支援此影片網址
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="views-bulletin-settings__body-form-item__video-right-wrapper">
                      <el-button
                        type="danger"
                        class="views-bulletin-settings__body-form-item__video-right__button"
                        plain
                        @click.prevent="removeVideo(item)"
                      >
                        刪除
                      </el-button>
                    </div>
                  </el-form>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>

          <el-form-item
            label="跑馬燈管理"
            class="views-bulletin-settings__body-form-item"
          >
            <div class="views-bulletin-settings__body-form-item__marquee__title">
              <ul>
                <li>跑馬燈總數：{{ form.marquee.length }} 組 / 10 組</li>
                <li>可自訂文字內容(字數限制 250 字)、文字顏色(自行選色)、背景顏色(自行選色)、刊登時間(自訂刊登起訖時間)</li>
                <li>以上資訊皆<span class="views-bulletin-settings__body-form-item__required--red">必填*</span></li>
              </ul>
            </div>
            <el-button
              class="views-bulletin-settings__body-form-item__marquee__title-button"
              :disabled="form.marquee.length >= 10"
              @click="addMarquee"
            >
              新增跑馬燈
            </el-button>
            <div
              v-for="item in form.marquee"
              :key="item.Sequence"
            >
              <el-form
                :ref="`ruleMarquee${item.Sequence}`"
                class="views-bulletin-settings__body-form-item__marquee"
                :model="item"
                :rules="rulesMarquee"
                status-icon
                :show-message="false"
                label-position="left"
              >
                <div class="views-bulletin-settings__body-form-item__marquee-card__header-wrapper">
                  <div class="views-bulletin-settings__body-form-item__marquee-card__header">
                    {{ item.Sequence }}.
                    <el-button
                      type="danger"
                      plain
                      class="views-bulletin-settings__body-form-item__marquee-card__header-button"
                      @click="removeMarquee(item)"
                    >
                      刪除
                    </el-button>
                  </div>
                </div>
                <div class="views-bulletin-settings__body-form-item__marquee__content-wrapper">
                  <div class="views-bulletin-settings__body-form-item__marquee__content-title">
                    文字內容
                  </div>
                  <el-form-item prop="Message">
                    <el-input
                      v-model="item.Message"
                      class="views-bulletin-settings__body-form-item__marquee__content-input"
                      placeholder="請輸入跑馬燈內容"
                      maxlength="250"
                      show-word-limit
                    />
                  </el-form-item>
                </div>
                <div class="views-bulletin-settings__body-form-item__marquee__color-wrapper">
                  <div class="views-bulletin-settings__body-form-item__marquee__color">
                    <div class="views-bulletin-settings__body-form-item__marquee__color-top">
                      <div>文字顏色</div>
                      <el-form-item prop="FontColor">
                        <el-color-picker
                          v-model="item.FontColor"
                          class="views-bulletin-settings__body-form-item__marquee__color-top-margin"
                        />
                      </el-form-item>
                      <span class="views-bulletin-settings__body-form-item__marquee__color-top-margin">{{ item.FontColor
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="views-bulletin-settings__body-form-item__marquee__color-preview-wrapper views-bulletin-settings__body-form-item__marquee__color-preview-wrapper--light"
                  >
                    <div
                      class="views-bulletin-settings__body-form-item__marquee__color-preview views-bulletin-settings__body-form-item__marquee__color-preview--light"
                      :style="{ 'color': item.FontColor }"
                    >
                      跑馬燈內容跑馬燈內容跑馬燈內容
                    </div>
                  </div>
                  <div
                    class="views-bulletin-settings__body-form-item__marquee__color-preview-wrapper views-bulletin-settings__body-form-item__marquee__color-preview-wrapper--dark"
                  >
                    <div
                      class="views-bulletin-settings__body-form-item__marquee__color-preview views-bulletin-settings__body-form-item__marquee__color-preview--dark"
                      :style="{ 'color': item.FontColor }"
                    >
                      跑馬燈內容跑馬燈內容跑馬燈內容
                    </div>
                  </div>
                </div>
                <div class="views-bulletin-settings__body-form-item__marquee__time-wrapper">
                  刊登時間
                  <el-form-item prop="Date">
                    <el-date-picker
                      v-model="item.Date"
                      class="views-bulletin-settings__body-form-item__marquee__time-margin"
                      size="large"
                      type="datetimerange"
                      start-placeholder="請選擇刊登起日"
                      range-separator="至"
                      end-placeholder="請選擇刊登訖日"
                      format="yyyy-MM-dd HH:mm"
                      :default-time="['00:00:00', '23:59:59']"
                    />
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="views-bulletin-settings__footer">
        <el-button
          :disabled="isSubmitting"
          round
          @click="goPageBulletin"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :disabled="isSubmitting"
          round
          @click="beforeSubmitForm"
        >
          送出
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
  components: {
    Draggable
  },
  data () {
    return {
      isSubmitting: false,
      form: {
        video: [],
        marquee: []
      },
      rules: {},
      rulesVideo: {
        Url: [
          { required: true, message: '', trigger: 'blur' },
          { validator: this.validateVideo, trigger: ['blur', 'change'] }
        ]
      },
      rulesMarquee: {
        Message: [{ required: true, message: '', trigger: 'blur' }],
        FontColor: [{ required: true, message: '', trigger: 'change' }],
        BackgroundColor: [{ required: true, message: '', trigger: 'change' }],
        Date: [{ required: true, message: '', trigger: 'change' }]
      }
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 400,
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  mounted () {
    this.initPage()
  },
  beforeDestroy () {
  },
  methods: {
    async initPage () {
      await this.getList()
      this.initCheckVideoUrl()
    },
    async getList () {
      try {
        const { data } = await apiBulletin.getSettings()
        console.log('getList data', data)

        this.form.video = data.YouTubes
        this.form.marquee = data.Marquees

        if (this.form.video.length > 0) this.form.video.sort((a, b) => a.Sequence - b.Sequence)

        this.form.video = this.form.video.map(e => {
          return { ...e, Title: '', Thumbnail: '', Error: false }
        })

        if (this.form.marquee.length > 0) {
          this.form.marquee = this.form.marquee.map(e => {
            return { ...e, Date: [e.StartAt, e.EndAt] }
          })
        }

        console.log('this.form.video', this.form.video)
        console.log('this.form.marquee', this.form.marquee)
      } catch (error) {
        console.log('error', error)
        this.$message.error('伺服器發生錯誤')
      }
    },
    addVideo () {
      this.form.video.push({ Sequence: this.form.video.length + 1, Url: '', Title: '', Thumbnail: '', Error: false })
    },
    removeVideo (item) {
      const index = this.form.video.indexOf(item)
      if (index !== -1) {
        this.form.video.splice(index, 1)
      }
      this.updateVideoListSortOrder(item)
    },
    updateVideoListSortOrder ({ moved }) {
      console.log('updateVideoListSortOrder', moved)
      this.form.video = this.form.video.map((item, index) => {
        const newSort = index + 1
        if (item.Sequence !== newSort) item.Sequence = newSort
        return item
      })
    },
    async validateVideo (rule, value, callback) {
      console.log('validateVideo', value)
      const _isValidYouTubeUrl = this.isValidYouTubeUrl(value)
      const _isValidYouTubeApi = await this.isValidYouTubeApi(value)
      console.log('validateVideo _isValidYouTubeUrl', _isValidYouTubeUrl)
      console.log('validateVideo _isValidYouTubeApi', _isValidYouTubeApi)

      if (_isValidYouTubeUrl && _isValidYouTubeApi) callback()
      else callback(new Error('請輸入正確的影片網址'))
    },
    initCheckVideoUrl () {
      if (this.form.video.length > 0) {
        this.form.video.map((e, index) => {
          this.checkVideoUrl(e.Url, index)
        })
      }
    },
    checkVideoUrl (url, index) {
      this.form.video[index].Title = ''
      this.form.video[index].Thumbnail = ''
      this.form.video[index].Error = false
      if (this.isValidYouTubeUrl(url)) {
        this.getVideoInfo(url, index)
      }
    },
    async getVideoInfo (url, index) {
      console.log('getVideoInfo url', url)
      const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*$/
      const match = url.match(regExp)
      if (match && match[2].length === 11) {
        try {
          console.log('getVideoInfo match', match)
          console.log('getVideoInfo index', index)
          const url = `https://youtu.be/${match[2]}`

          const res = await axios(`https://www.youtube.com/oembed?url=${url}&format=json`)
          this.form.video[index].Title = res.data.title
          console.log('getVideoInfo res', res)

          this.form.video[index].Thumbnail = `https://img.youtube.com/vi/${match[2]}/0.jpg`
        } catch (error) {
          console.log('getVideoInfo error response', error.response)
          this.$message.error('請重新確認影片網址')
          this.form.video[index].Title = ''
          this.form.video[index].Thumbnail = ''
          this.form.video[index].Error = true
        }
      } else {
        this.$message.error('請重新確認影片網址')
        this.form.video[index].Title = ''
        this.form.video[index].Thumbnail = ''
        this.form.video[index].Error = true
      }
    },
    addMarquee () {
      this.form.marquee.push({
        Sequence: this.form.marquee.length + 1,
        Message: '',
        FontColor: '#FFFFFF',
        BackgroundColor: 'rgba(255, 255, 255, 0.3)',
        Date: []
      })
    },
    removeMarquee (item) {
      const index = this.form.marquee.indexOf(item)
      if (index !== -1) {
        this.form.marquee.splice(index, 1)
      }
      this.updateMarqueeListSortOrder()
    },
    updateMarqueeListSortOrder () {
      this.form.marquee = this.form.marquee.map((item, index) => {
        const newSort = index + 1
        if (item.Sequence !== newSort) item.Sequence = newSort
        return item
      })
    },
    goPageBulletin () {
      this.$router.push({ name: 'BulletinIndex' })
    },
    beforeSubmitForm () {
      const vm = this
      const formArr = []
      const resArr = []

      function checkForm (formName) {
        const res = new Promise((resolve, reject) => {
          vm.$refs[formName][0].validate(valid => {
            if (valid) {
              resolve()
            } else {
              reject(new Error('表單驗證失敗'))
            }
          })
        })
        resArr.push(res)
      }

      this.form.video.map(e => formArr.push(`ruleVideo${e.Sequence}`))
      this.form.marquee.map(e => formArr.push(`ruleMarquee${e.Sequence}`))
      console.log('formArr', formArr)

      formArr.forEach(e => checkForm(e))
      console.log('resArr', resArr)

      Promise.all(resArr)
        .then(() => {
          this.submitForm()
        })
        .catch(() => {
          this.$message.error('請重新確認輸入內容')
          window.scrollTo({ top: 0, behavior: 'smooth' })
        })
    },
    async submitForm () {
      try {
        this.isSubmitting = true
        console.log('this.form.video', this.form.video)
        console.log('this.form.marquee', this.form.marquee)

        if (this.form.marquee.length > 0) {
          this.form.marquee = this.form.marquee.map(e => {
            return { ...e, StartAt: e.Date[0], EndAt: e.Date[1] }
          })
        }

        const params = {
          youTubes: this.form.video,
          marquees: this.form.marquee
        }
        console.log('submitForm params', params)
        await apiBulletin.newSettings(params)
        this.$message.success('內容管理設定成功')
        this.goPageBulletin()
      } catch (error) {
        this.$message.error('伺服器發生錯誤')
        console.log('error', error)
      } finally {
        this.isSubmitting = false
      }
    },
    isValidYouTubeUrl (value) {
      const rules = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/
      console.log('isValidYouTubeUrl', rules.test(value))
      return rules.test(value)
    },
    async isValidYouTubeApi (url) {
      console.log('isValidYouTubeApi url', url)
      const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*$/
      const match = url.match(regExp)
      if (match && match[2].length === 11) {
        try {
          console.log('isValidYouTubeApi match', match)
          const url = `https://youtu.be/${match[2]}`
          await axios(`https://www.youtube.com/oembed?url=${url}&format=json`)
          return true
        } catch (error) {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="sass">

.views-bulletin-settings
  width: 100%
  height: 100%

.views-bulletin-settings-wrapper
  min-width: 1140px
  max-width: 1140px
  margin: 50px auto 10px auto
  padding: 30px
  color: $mainFontColor
  background-color: $white
  box-sizing: border-box
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
  border-radius: $pageBorderRadius

.views-bulletin-settings__header
  display: flex
  justify-content: space-between
  align-items: center

.views-bulletin-settings__header-left
  color: $mainFontColor
  font-weight: bold
  font-size: map-get($fontSize,xx-large)

.views-bulletin-settings__body
  display: flex
  justify-content: center
  margin: 30px 0
  width: 100%
  box-sizing: border-box

.views-bulletin-settings__body-form
  width: 100%
  max-width: 600px
  margin: 0 auto

.views-bulletin-settings__body-form .el-form-item
  margin-bottom: 60px

.views-bulletin-settings__body-form .el-form-item__label
  font-size: 20px
  font-weight: bold

.views-bulletin-settings__body-form-item
  width: 600px

.views-bulletin-settings__body-form-item__required--red
  color: #c44536

.views-bulletin-settings__body-form-item__video__title
  line-height: 1.7

.views-bulletin-settings__body-form-item__video__title-button
  margin-top: 10px
  margin-bottom: 20px

.views-bulletin-settings__body-form-item__video
  display: flex
  padding: 10px
  margin-bottom: 20px
  border: solid 1px $borderDark1
  border-radius: $pageBorderRadius
  background-color: $white
  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.2)

.views-bulletin-settings__body-form-item__video .el-form-item
  margin-bottom: 0

.views-bulletin-settings__body-form-item__video-left
  width: 45px
  display: flex
  justify-content: center
  align-items: center
  padding-left: 5px
  padding-right: 15px

.views-bulletin-settings__body-form-item__video-left__icon
  margin-left: 5px
  width: 14px
  height: 14px
  color: $white
  background-color: $mainColor
  border-radius: 50%
  padding: 3px
  cursor: move

.views-bulletin-settings__body-form-item__video-middle__input,
.views-bulletin-settings__body-form-item__video-middle__title
  display: flex
  width: 420px

.views-bulletin-settings__body-form-item__video-middle__title--red
  color: #c44536

.views-bulletin-settings__body-form-item__video-middle__input .el-input__inner
  padding-right: 30px

.views-bulletin-settings__body-form-item__video-middle__thumbnail-wrapper
  display: flex

.views-bulletin-settings__body-form-item__video-middle__thumbnail
  width: 200px
  height: 150px
  border-radius: $pageBorderRadius

.views-bulletin-settings__body-form-item__video-middle__thumbnail[src=''],
.views-bulletin-settings__body-form-item__video-middle__thumbnail:not([src])
  opacity: 0

.views-bulletin-settings__body-form-item__video-right-wrapper
  display: flex
  flex: 1
  justify-content: end

.views-bulletin-settings__body-form-item__video-right__button
  height: 40px
  display: flex

.views-bulletin-settings__body-form-item__marquee__title
  line-height: 1.7

.views-bulletin-settings__body-form-item__marquee__title-button
  margin-top: 10px
  margin-bottom: 20px

.views-bulletin-settings__body-form-item__marquee
  padding: 10px
  margin-bottom: 20px
  border: solid 1px $borderDark1
  border-radius: $pageBorderRadius
  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.2)

.views-bulletin-settings__body-form-item__marquee .el-form-item
  margin-bottom: 0

.views-bulletin-settings__body-form-item__marquee-card__header-wrapper
  margin-bottom: 10px

.views-bulletin-settings__body-form-item__marquee-card__header
  display: flex
  justify-content: space-between

.views-bulletin-settings__body-form-item__marquee-card__header-button
  margin-left: 10px

.views-bulletin-settings__body-form-item__marquee__content-wrapper
  display: flex
  margin-bottom: 10px

.views-bulletin-settings__body-form-item__marquee__content-title
  min-width: 56px

.views-bulletin-settings__body-form-item__marquee__content-input
  width: 512px
  margin-left: 10px

.views-bulletin-settings__body-form-item__marquee__content-input .el-input__inner
  padding-right: 80px

.views-bulletin-settings__body-form-item__marquee__color-wrapper
  display: flex
  flex-direction: column
  margin-bottom: 10px

.views-bulletin-settings__body-form-item__marquee__color
  display: flex
  width: 100%
  height: 40px

.views-bulletin-settings__body-form-item__marquee__color-top
  display: flex
  flex: 1

.views-bulletin-settings__body-form-item__marquee__color-top-margin
  margin-left: 10px

.views-bulletin-settings__body-form-item__marquee__color-preview-wrapper
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  height: 80px
  border-radius: $pageBorderRadius
  margin-top: 5px

.views-bulletin-settings__body-form-item__marquee__color-preview-wrapper--light
  background: linear-gradient(90deg, #59A3CC 0%, #2878A4 100%)

.views-bulletin-settings__body-form-item__marquee__color-preview-wrapper--dark
  background: #313839

.views-bulletin-settings__body-form-item__marquee__color-preview
  width: 100%
  height: 100%
  display: flex
  justify-content: center
  align-items: center
  border-radius: $pageBorderRadius
  font-size: 30px
  font-weight: bold

.views-bulletin-settings__body-form-item__marquee__color-preview--light
  background: rgba(255, 255, 255, 0.3)

.views-bulletin-settings__body-form-item__marquee__color-preview--dark
  background: rgba(81, 81, 81, 0.9)

.views-bulletin-settings__body-form-item__marquee__time-wrapper
  display: flex
  margin-bottom: 10px

.views-bulletin-settings__body-form-item__marquee__time-margin
  margin-left: 10px

.views-bulletin-settings__footer
  display: flex
  justify-content: center
  padding-top: 30px
  border-top: solid 1px $borderDark1
</style>
